/**
 * The settings tab that manages billing for a workspace of the given type.
 * Team workspaces have their own Billing tab (`ws-billing`); personal
 * workspaces use the personal Subscription tab. Used by the sidebar's upgrade
 * deep-link so the modal opens to the right tab for the active workspace.
 */
export function subscriptionTabForWorkspace(type: 'personal' | 'team' | undefined): string {
  return type === 'team' ? 'ws-billing' : 'subscription';
}
